// src/components/ui/feedback/Alert/Alert.jsx
import React from 'react';
import { AlertCircle, CheckCircle2, AlertTriangle, Info } from 'lucide-react';
import { cn } from '../../../../utils/cn';

const Alert = ({
  variant = 'error',
  children,
  icon: CustomIcon,
  showIcon = true,
  className = '',
  onClose
}) => {
  // Icon mapping
  const iconMap = {
    error: AlertCircle,
    success: CheckCircle2,
    warning: AlertTriangle,
    info: Info
  };

  // Variant styles matching the login page
  const variantStyles = {
    error: cn(
      "bg-red-900/20 border border-red-500/30 text-red-300",
      "backdrop-blur-sm"
    ),
    success: cn(
      "bg-emerald-900/20 border border-emerald-500/30 text-emerald-300",
      "backdrop-blur-sm"
    ),
    warning: cn(
      "bg-amber-900/20 border border-amber-500/30 text-amber-300",
      "backdrop-blur-sm"
    ),
    info: cn(
      "bg-blue-900/20 border border-blue-500/30 text-blue-300",
      "backdrop-blur-sm"
    )
  };

  // Get the appropriate icon
  const Icon = CustomIcon || iconMap[variant];

  return (
    <div className={cn(
      "p-4 rounded-xl",
      variantStyles[variant],
      className
    )}>
      <div className="flex items-center gap-3">
        {/* Icon */}
        {showIcon && Icon && (
          <Icon className="w-5 h-5 flex-shrink-0" />
        )}
        
        {/* Content */}
        <div className="flex-1">
          {typeof children === 'string' ? (
            <p className="text-sm">{children}</p>
          ) : (
            children
          )}
        </div>

        {/* Close Button */}
        {onClose && (
          <button
            onClick={onClose}
            className="flex-shrink-0 p-1 rounded-lg hover:bg-white/10 transition-colors"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path 
                fillRule="evenodd" 
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" 
                clipRule="evenodd" 
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default Alert;